import React from "react";
import { scaleLinear } from "d3";

interface GaugeRegionalPointProps {
    value: number;
}

export const GaugeRegionalPoint = (props: GaugeRegionalPointProps) => {
    const { value } = props;
    const percentScale = scaleLinear().domain([0, 100]).range([0, 1]);
    const percent = percentScale(value);

    const angleScale = scaleLinear()
        .domain([0, 1])
        .range([-Math.PI / 2, Math.PI / 2])
        .clamp(true);

    const angle = angleScale(percent);

    const getCoordsOnArc = () => [
        (angle - 8) * 0.005 - Math.PI * 0.005,
        Math.sin(angle * 0.005 - Math.PI * 0.5) - 0.15,
    ];

    const markerLocation = getCoordsOnArc();

    return (
        <polygon
            points="0,0 .1,0 .05,.1"
            transform={`rotate(${angle * (180 / Math.PI)}) translate(${
                markerLocation[0]
            }, ${markerLocation[1]})`}
            fill="#210071"
        />
    );
};
